import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const GLOSSARY_TERMS = [
  {
    term: "AIA G702/G703",
    definition:
      "Standard forms published by the American Institute of Architects used for applications and certificates for payment. The G702 is the Application and Certificate for Payment, and the G703 is the Continuation Sheet that details the schedule of values.",
  },
  {
    term: "RFI (Request for Information)",
    definition:
      "A formal written process used to request clarification or additional information about construction documents, plans, specifications, or other contract documents from the architect, engineer, or owner.",
  },
  {
    term: "Submittal",
    definition:
      "Documentation provided by the contractor to the architect or engineer for review and approval, including shop drawings, product data, samples, and other items required by the contract documents.",
  },
  {
    term: "Punch List",
    definition:
      "A list of work items that do not conform to the contract specifications, typically generated near the end of a project. These items must be completed or corrected before final payment is made.",
  },
  {
    term: "Retainage",
    definition:
      "A percentage of the payment (typically 5-10%) withheld from the contractor during construction to ensure project completion. It is released after substantial completion and resolution of all punch list items.",
  },
  {
    term: "Change Order",
    definition:
      "A written amendment to the construction contract that modifies the scope of work, contract sum, or contract time. Change orders must be agreed upon by the owner, contractor, and architect.",
  },
  {
    term: "Lien Waiver",
    definition:
      "A legal document signed by a contractor, subcontractor, or supplier waiving their right to file a mechanic's lien against a property. Lien waivers can be conditional (contingent on payment) or unconditional.",
  },
  {
    term: "COI (Certificate of Insurance)",
    definition:
      "A document issued by an insurance company verifying that a contractor or subcontractor has the required insurance coverage, including general liability, workers' compensation, and auto insurance.",
  },
  {
    term: "NTP (Notice to Proceed)",
    definition:
      "A formal written communication from the owner to the contractor authorizing commencement of work on a project. The NTP establishes the official start date from which the contract time begins.",
  },
  {
    term: "Substantial Completion",
    definition:
      "The stage of a project when the work is sufficiently complete so the owner can occupy or use it for its intended purpose. This milestone triggers the start of warranty periods and the release of retainage.",
  },
] as const;

export function GlossaryPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Construction Glossary</h1>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Common Construction Terms</CardTitle>
        </CardHeader>
        <CardContent>
          <Accordion type="single" collapsible className="w-full">
            {GLOSSARY_TERMS.map((item) => (
              <AccordionItem key={item.term} value={item.term}>
                <AccordionTrigger className="text-left font-semibold">{item.term}</AccordionTrigger>
                <AccordionContent className="text-muted-foreground">
                  {item.definition}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </CardContent>
      </Card>
    </div>
  );
}
